import callout from './callout.reducer';

const reducer = callout;

export default reducer;
